<template>
<div class=""  style="padding:0 20px;">

  <el-form ref="formBasic" :model="vonpazienti" @submit.native.prevent="onImport" :rules="rules" label-width="180px" style="margin-top:20px;" class="label-30">

   <div class="title_h1 yo-color-primary">IMPORTA FILE CSV DAL VON</div>



   <div class="row " style="margin-top:20px;">
 

      <div class="col s12 m6 clear">
         <div class="col s4"><label for="eposter" class="el-form-item__label" style="width:100% !important">Documento (csv)</label></div>
         <upload class="col s8" 
         :value="vonpazienti.file" 
         
         v-on:success="importSuccess" 

         action="https://fad.mzcongressi.com/202009/vue/upload/"  
         savedir="/www/fad.mzcongressi.com/zoom/partecipanti/von" 
         previewurl="https://fad.mzcongressi.com/zoom/partecipanti/von/"


         next_action="https://api.innsin.it:14439/201806/vue/upload/"  
         next_savedir="www.innsin.it/upload/von" 
         next_previewurl="https://www.innsin.it/upload/von/"
         extensions="csv"></upload>
      </div>

   </div>  
   <!--

   <div class="container row pad corso" style="margin-top:16px;" v-if="parseInt(riunione.id)>0">
      <div class="col s12 m3 clear yo-color-primary yo-text-bold yo-color-primary yo-text-bold" :class="($teras.app.device=='desktop') ? 'yo-align-right' : ''" >ID riunione</div>
      <div class="col s12 m9">{{riunione.id | sevuoto('n.d.')}} - {{riunione.evento | sevuoto('n.d.')}}</div>
      <div class="col s12 m3 clear yo-color-primary yo-text-bold yo-color-primary yo-text-bold" :class="($teras.app.device=='desktop') ? 'yo-align-right' : ''" >Argomento</div>
      <div class="col s12 m9">{{riunione.argomento | sevuoto('n.d.')}}</div>
      <div class="col s12 m3 clear yo-color-primary yo-text-bold yo-color-primary yo-text-bold" :class="($teras.app.device=='desktop') ? 'yo-align-right' : ''" >Lezione</div>
      <div class="col s12 m9">{{riunione.lezione | sevuoto('n.d.')}}</div>

      <div class="col s12 m3 clear yo-color-primary yo-text-bold yo-color-primary yo-text-bold" :class="($teras.app.device=='desktop') ? 'yo-align-right' : ''" >Periodo</div>
      <div class="col s12 m9">{{riunione.inizio | data('DD MMMM YYYY \\d\\a\\l\\l\\e HH:mm')}} alle {{riunione.fine | data('HH:mm')}}</div>
      
      


      <div class="col s12 m3 clear yo-color-primary yo-text-bold yo-color-primary yo-text-bold" :class="($teras.app.device=='desktop') ? 'yo-align-right' : ''" >Durata (minuti)</div>
      <div class="col s12 m9">{{riunione.durata | sevuoto('n.d.')}}</div>
      <div class="col s12 m3 clear yo-color-primary yo-text-bold yo-color-primary yo-text-bold" :class="($teras.app.device=='desktop') ? 'yo-align-right' : ''" >Presenza minima (minuti)</div>
      <div class="col s12 m9">{{riunione.duratamin | sevuoto('n.d.')}}</div>
      <div class="col s12 m3 clear yo-color-primary yo-text-bold yo-color-primary yo-text-bold" :class="($teras.app.device=='desktop') ? 'yo-align-right' : ''" >Partecipanti</div>
      <div class="col s12 m9">{{riunione.partecipanti | sevuoto('n.d.')}}</div>


   </div>


   <div class="container row pad corso" style="margin-top:16px;"  v-for="(item,index) in this.partecipante"  v-bind:key="index" >

      <div class="col s12 m3 clear yo-color-primary yo-text-bold yo-color-primary yo-text-bold" :class="($teras.app.device=='desktop') ? 'yo-align-right' : ''" >{{index+1}}</div>
      <div class="col s12 m6">{{item.nome | sevuoto('n.d.')}}</div>

      <div class="col s12 m1 yo-align-right" v-if="item.contatto>0">{{item.contatto}}</div>
      <div class="col s12 m1 yo-align-right" v-else>NO</div>
      <div class="col s12 m1 yo-align-right">{{item.durata}} min.</div>
     
      <div class="col s12 m1 yo-align-left yo-color-success" v-if="item.ecm==1"><span class="material-icons">school</span></div>
      <div class="col s12 m1 yo-align-left yo-color-danger" v-else><span class="material-icons">warning</span></div>
  </div> 
-->

    <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s6 m4 offset-m2">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Cancel</el-button>
      </div>
        
      <div class="col s6 m4 offset-m2" >
          <el-button type="primary" @click="papaparse" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Importa</el-button>
      </div>
    </div>


    </el-form>


{{readytoimport.length}}


   
<div>
  <div class="yo-text-xs" v-for="(itm,index) in error" :item="itm" :numero="index+1" v-bind:key="index">{{itm.error}}</div> 
</div>

</div>
</template>

<script>

import Papa from 'papaparse'

/* v-on:change="val => vonpazienti.file=val" */
import upload from './Upload.vue'
export default {
  name: 'zoom-partecipanti',
  components: {
      upload
  },
  data() {
    return {
      vonpazienti: {file:[]},
      filedata: {},
      pazienti:[],
      pazientiNNSIN:[],


      readytoimport: [],
      error: []
    }
  },
  created () {
    console.log("Arrivo al von-import.vue")
  },
  beforeDestroy () {

  },
   methods: {
    async importSuccess(filedata,response,file,filelist) {
      this.filedata=JSON.parse(filedata)[0]
      console.log(this.filedata.name)
      console.log(response)
      console.log(file)
      console.log(filelist)

      Papa.parse('https://fad.mzcongressi.com/zoom/partecipanti/von/'+this.filedata.url, {
        header: true,
        download: true,
        complete: async (results) => { 
          this.pazienti = results.data
          console.log(results.data)
          

        }
        
      })
    },
    async papaparse() {
      let error = []
      let i=0
      this.readytoimport = []
      this.pazientiNNSIN = []
      this.error = []
      for(let item of this.pazienti){
        if(item.HOSPNO<1)
          break
        error = []
        i++
        //Controllo che esiste in centro registrato con quel numero VON
        let checkVON = await this.$axios.query('fetchRow',`
        SELECT centro.id AS id, struttura.id AS struttura,von,von_old 
        FROM centro LEFT JOIN struttura ON struttura.id=centro.codiceministeriale 
        where struttura.von=→hospno
        `,{hospno: item.HOSPNO})

        console.log(checkVON.result)
        if(checkVON.result.von != item.HOSPNO){
          error.push({id:item.ID, von:item.HOSPNO, type:101, message:'Il centro VON '+item.HOSPNO+' non sembra registrato in NNSIN'})
        }

        //controllo che non sia già presente un paziente con quel numero VON per il centro
        let checkPaziente = await this.$axios.query('fetchRow',`
        SELECT paziente.id,paziente.centro,struttura.id AS struttura,von,von_old,vonnumber 
        FROM paziente lEFT JOIN centro ON centro.id=paziente.centro LEFT JOIN struttura ON struttura.id=centro.codiceministeriale 
        where paziente.vonnumber=→id AND struttura.von=→hospno AND paziente.creatoda>0
        `,{hospno: item.HOSPNO,id: item.ID})
        console.log(checkPaziente.result)
        if(checkPaziente.result.vonnumber == item.ID){
          error.push({id:item.ID, von:item.HOSPNO, type:102, message:'Il bambino '+item.ID+' del centro VON '+item.HOSPNO+' sembra essere già registrato in NNSIN con id: '+checkPaziente.result.id})
        }
      
        if(error.length>0){
          console.error("error in papaparse")
          this.error.push({row:i, error: error})
        }else{
          let NNSINkeyvalue = {key:'',value:''}
          let pazienteNNSIN = {}
          this.readytoimport.push(item)
          pazienteNNSIN['centro'] = checkVON.result.id
          pazienteNNSIN['vonnumber'] = item.ID
          pazienteNNSIN['chiusoil'] = this.$moment().format('YYYY-MM-DD HH:mm'+':00')
          pazienteNNSIN['vonil'] = this.$moment().format('YYYY-MM-DD HH:mm'+':10')
          delete item['ID']

          /*
          NNSINkeyvalue = await this.toNNSINvalue('SEX',item['SEX'])
          console.error(NNSINkeyvalue)
          console.error(item['SEX'])
          */
          let is127 = 0
          let campi127 = []
          for (var key in item) {
              
            //if(key == 'OUTB_CTR'){
              NNSINkeyvalue = await this.toNNSINvalue(key,item[key])
              //console.log(NNSINkeyvalue)
              //console.error(key+':'+item[key]+' => '+NNSINkeyvalue.key+':'+NNSINkeyvalue.value)

              if(NNSINkeyvalue.value == -127){
                campi127.push(key)
                is127++
              }

              if(NNSINkeyvalue.key != 'iserror')
                pazienteNNSIN[NNSINkeyvalue.key] = NNSINkeyvalue.value
            //}

            if(key == 'SRGCD1'){
              pazienteNNSIN['srgcd1gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD2'){
              pazienteNNSIN['srgcd2gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD3'){
              pazienteNNSIN['srgcd3gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD4'){
              pazienteNNSIN['srgcd4gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD5'){
              pazienteNNSIN['srgcd5gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD6'){
              pazienteNNSIN['srgcd6gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD7'){
              pazienteNNSIN['srgcd7gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD8'){
              pazienteNNSIN['srgcd8gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD9'){
              pazienteNNSIN['srgcd9gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }
            if(key == 'SRGCD10'){
              pazienteNNSIN['srgcd10gruppo'] = (parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0) ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1) : pazienteNNSIN[NNSINkeyvalue.key]
            }


            if(key == 'BDCD1'){ 
              if(parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0){
                pazienteNNSIN['bdcd1gruppo'] = parseInt(pazienteNNSIN[NNSINkeyvalue.key])>999 ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 2) : String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1)
              }else{
                pazienteNNSIN['bdcd1gruppo'] = pazienteNNSIN[NNSINkeyvalue.key]
              }
            }
            if(key == 'BDCD2'){ 
              if(parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0){
                pazienteNNSIN['bdcd2gruppo'] = parseInt(pazienteNNSIN[NNSINkeyvalue.key])>999 ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 2) : String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1)
              }else{
                pazienteNNSIN['bdcd2gruppo'] = pazienteNNSIN[NNSINkeyvalue.key]
              }
            }          
            if(key == 'BDCD3'){ 
              if(parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0){
                pazienteNNSIN['bdcd3gruppo'] = parseInt(pazienteNNSIN[NNSINkeyvalue.key])>999 ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 2) : String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1)
              }else{
                pazienteNNSIN['bdcd3gruppo'] = pazienteNNSIN[NNSINkeyvalue.key]
              }
            } 
            if(key == 'BDCD4'){ 
              if(parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0){
                pazienteNNSIN['bdcd4gruppo'] = parseInt(pazienteNNSIN[NNSINkeyvalue.key])>999 ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 2) : String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1)
              }else{
                pazienteNNSIN['bdcd4gruppo'] = pazienteNNSIN[NNSINkeyvalue.key]
              }
            }
            if(key == 'BDCD5'){ 
              if(parseInt(pazienteNNSIN[NNSINkeyvalue.key])>0){
                pazienteNNSIN['bdcd5gruppo'] = parseInt(pazienteNNSIN[NNSINkeyvalue.key])>999 ? String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 2) : String(pazienteNNSIN[NNSINkeyvalue.key]).substring(0, 1)
              }else{
                pazienteNNSIN['bdcd5gruppo'] = pazienteNNSIN[NNSINkeyvalue.key]
              }
            } 



              
          }

          if(is127>0){
            pazienteNNSIN['chiusoil'] = '0000-00-00 00:00:00'
            pazienteNNSIN['chiusoda'] = '-127'
            pazienteNNSIN['cognome'] = 'VON CON VARIABILI VUOTE'
            this.error.push({row:i, error: {id:item.ID, von:item.HOSPNO, type:127, message:'Il bambino '+pazienteNNSIN['vonnumber']+' del centro VON '+item.HOSPNO+' non ha compilato: '+campi127}})
                
          }

          pazienteNNSIN['ncartellaclinica'] = '-9'
          pazienteNNSIN['primogenito'] = '-9'
          pazienteNNSIN['lunghezzanascita'] = '-9'
          pazienteNNSIN['etamaterna'] = '-9'
          pazienteNNSIN['statomadre'] = '-9'
          pazienteNNSIN['titolomadre'] = '-9'
          pazienteNNSIN['hmadre'] = '-9'
          pazienteNNSIN['pmadre'] = '-9'
          pazienteNNSIN['patomadre'] = '-9'
          pazienteNNSIN['patomadretipo'] = '-9'
          pazienteNNSIN['pma'] = '-9'
          pazienteNNSIN['tipoaster'] = '-9'
          pazienteNNSIN['iugr'] = '-9'
          pazienteNNSIN['benfetale'] = '-9'
          pazienteNNSIN['tttdec'] = '-9'
          pazienteNNSIN['multmonoc'] = '-9'
          pazienteNNSIN['anomplacenta'] = '-9'
          pazienteNNSIN['prom'] = '-9'
          pazienteNNSIN['initrav'] = '-9'
          pazienteNNSIN['sli'] = '-9'
          pazienteNNSIN['patoresp'] = '-9'
          pazienteNNSIN['fio2surf'] = '-9'
          pazienteNNSIN['nsurf'] = '-9'
          pazienteNNSIN['insure'] = '-9'
          pazienteNNSIN['lisa'] = '-9'
          pazienteNNSIN['tipoprelisa'] = '-9'
          pazienteNNSIN['prelisa'] = '-9'
          pazienteNNSIN['apnea'] = '-9'
          pazienteNNSIN['ttn'] = '-9'
          pazienteNNSIN['bpd'] = '-9'
          pazienteNNSIN['bpdgrado'] = '-9'
          pazienteNNSIN['pvlgrado'] = '-9'
          pazienteNNSIN['tcaffeine'] = '-9'
          pazienteNNSIN['gginicaffeine'] = '-9'
          pazienteNNSIN['eii'] = '-9'
          pazienteNNSIN['ipotermia'] = '-9'
          pazienteNNSIN['npgg'] = '-9'
          pazienteNNSIN['fef'] = '-9'
          pazienteNNSIN['fefgg'] = '-9'
          pazienteNNSIN['colestasi'] = '-9'
          pazienteNNSIN['epo'] = '-9'
          pazienteNNSIN['ec'] = '-9'
          pazienteNNSIN['supportodim'] = '-9'
          pazienteNNSIN['fio236'] = '-9'
          pazienteNNSIN['ldimissione'] = '-127'  //DA VERIFICARE SE VIENE CALCOLATA POI IN AUTOMATICO
          pazienteNNSIN['negg'] = '-9'
          pazienteNNSIN['neconlm'] = '-9'
          pazienteNNSIN['neconla'] = '-9'
          pazienteNNSIN['neconlm_la'] = '-9'
          pazienteNNSIN['digiuno'] = '-9'
          pazienteNNSIN['lmbanca'] = '-9'
          pazienteNNSIN['lmfortificato'] = '-9'
          pazienteNNSIN['proteine'] = '-9'
          pazienteNNSIN['inizionegg'] = '-9'
          pazienteNNSIN['rianimazionedr'] = '-9'

          this.pazientiNNSIN.push(pazienteNNSIN)
        }

        
        
      }

      //console.log(this.pazientiNNSIN)
      this.$axios.insertRows(this.pazientiNNSIN,'paziente')

    },
    async toNNSINvalue(key,value){
      let valueNNSIN = await this.$axios.query('fetchRow',`
      SELECT nome,von,
      CASE
        WHEN ncvon=→value THEN -9
        WHEN navon=→value THEN -7
        ELSE →value
      END AS value
      FROM variabile
      WHERE von=→key AND scheda>0
      `,{key: key, value: value})
      if(typeof valueNNSIN.result.von != 'undefined' && valueNNSIN.result.von.toLowerCase() == key.toLowerCase()){

        if( (key == 'OUTB_CTR'  || key == 'XFER_CTR' ) && valueNNSIN.result.value>0){
          let centroNNSIN = await this.$axios.query('fetchRow',`
          SELECT centro.id AS centro, struttura.id AS struttura,vontrf 
          FROM centro LEFT JOIN struttura ON struttura.id=centro.codiceministeriale 
          where struttura.vontrf=→von_ctr
          `,{von_ctr: valueNNSIN.result.value})
          if(typeof centroNNSIN.result.centro != 'undefined' && centroNNSIN.result.vontrf == valueNNSIN.result.value){
            valueNNSIN.result.value = centroNNSIN.result.centro
          }else{
            valueNNSIN.result.value = -5
          }

        }

        if( key == 'SRGCD1' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD2' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD3' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD4' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD5' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD6' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD7' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD8' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD9' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }

        if( key == 'SRGCD10' && typeof valueNNSIN.result.value != "number" && valueNNSIN.result.value.charAt(0)=='S'){
          valueNNSIN.result.value = valueNNSIN.result.value.substring(1)
        }


        if(valueNNSIN.result.value===''){
          valueNNSIN.result.value=-127
          console.error({key:valueNNSIN.result.nome.toLowerCase(), value:value})
        }

        return {key:valueNNSIN.result.nome.toLowerCase(), value:valueNNSIN.result.value}
      }else{
        return (typeof valueNNSIN.result.von != 'undefined') ? {key:valueNNSIN.result.nome.toLowerCase(), value:value} : {key:'iserror'}
      }


    },




    /*
    async importSuccess_complete(filedata,response,file,filelist) {
      //this.doUpdate()
      this.filedata=JSON.parse(filedata)[0]
      console.log(this.filedata.name)
      console.log(response)
      console.log(file)
      console.log(filelist)
      
      Papa.parse('/upload/von/'+this.filedata.url, {
        download: true,
        complete: async (results) => {
          await this.$axios.query('fetchRow',`SELECT 0 AS id,'' AS argomento,'' AS inizio,'' AS fine,'' AS email,0 AS partecipanti , id AS lezione,evento FROM lezione WHERE more=←riunione`,{riunione: results.data[1][0]},this,'riunione')
          
          if(results.data[1][0]>0 && this.riunione.evento && this.$evento.profile.row.id===this.riunione.evento){

            this.riunione.id=results.data[1][0]
            this.riunione.argomento=results.data[1][1]
            this.riunione.inizio=this.$moment(results.data[1][2])
            this.riunione.fine=this.$moment(results.data[1][3])
            this.riunione.email=results.data[1][4]
            this.riunione.durata=results.data[1][5]
            this.riunione.duratamin=parseInt(results.data[1][5]*90/100)
            this.riunione.partecipanti=results.data[1][6]
            console.log(this.riunione)

            let i=0
            let start=0
            this.partecipante = []
            for(let item of results.data){
              i++
              if(start==1 && parseInt(item[2])>0){
                let contatto = await this.$axios.query('fetchOne',`SELECT cnt.id FROM mz_emms.contatto AS cnt LEFT JOIN mz_emms.iscrizione AS iscr ON iscr.contatto=cnt.id WHERE iscr.evento=→evento AND cnt.email=→email`,{evento:this.$evento.profile.row.ems, email: item[1]})
                this.partecipante.push({'contatto':contatto.result,'nome':item[0],'email':item[1],'durata':item[2],'ecm':(item[2]>this.riunione.duratamin ? 1 : 0)})
          
              }
              if(item[0]=='Nome (nome originale)')  
                start=1

            }

            console.log(this.partecipante)
            this.$notify.success({type: 'info',message: 'File caricato correttamente, ora puoi procedere alla sua importazione', duration:5000}) 



          }else{
            console.log(this.$evento.profile.row.id+' ::'+this.riunione.evento)
            this.$alert( 'Il file non corrisponde al corso:<br />'+this.$evento.profile.row.titolo,'ERRORE',{type: 'error', dangerouslyUseHTMLString:true}) 

          }


           



          

          





        }
        
      })
      
         
        
    },
    */
    onCancel() {
      this.$router.push('/home/')
    },
    async onImport() {
      if(this.partecipante.length>0 && this.riunione.lezione>0){
        let logoperazione = []
        for(let item of this.partecipante){
          //console.log(item)
          if(item.ecm==1 && item.contatto>0){
            logoperazione.push({
              evento:this.$evento.profile.row.id
              ,contatto:item.contatto
              ,operazione:0
              ,operazioneid:this.riunione.lezione
              ,inizio:this.riunione.inizio.format('YYYY-MM-DD HH:mm:ss')
              ,fine:this.riunione.inizio.add(item.durata,'m').format('YYYY-MM-DD HH:mm:ss')
              ,device:'zoom'
            })
          }
        }
        console.log(logoperazione)
        if(logoperazione.length>0){
          await this.$axios.query('doQuery',`DELETE FROM log_operazioni WHERE evento=←evento AND operazioneid=←lezione`,{evento: this.$evento.profile.row.id, lezione:this.riunione.lezione})
          await this.$axios.insertRows(logoperazione,'log_operazioni')
          this.$notify.success({type: 'info',message: 'File importato correttamente!', duration:5000}) 
        }else{
          this.$alert( 'Non sono stati trovati contatti da importare','ERRORE',{type: 'error', dangerouslyUseHTMLString:true})
        }

      }else{
        this.$alert( 'Si sono verificati errori nell\'importare i dati del file csv','ERRORE',{type: 'error', dangerouslyUseHTMLString:true})
      }
    },
    async Save(){
      await this.$abstract.profile.save() 
      await this.$contatto.getAbstract() 
      console.log(this.$contatto._abstract)
      this.$router.push('/home/')      
    }

  },
  computed: {
    rules:function() {
      var rulesNow = {
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
</style>